import { render, staticRenderFns } from "./figure.vue?vue&type=template&id=0b58501e&scoped=true&"
import script from "./figure.vue?vue&type=script&lang=js&"
export * from "./figure.vue?vue&type=script&lang=js&"
import style0 from "./figure.vue?vue&type=style&index=0&id=0b58501e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58501e",
  null
  
)

export default component.exports